<script setup lang="ts">
import { Analytics } from '~/js/interfaces/analytics'

interface Props {
    url: string
    title: string
    target?: string
    ga: Analytics
}

withDefaults(defineProps<Props>(), {
    target: '_self'
})
</script>


<template>
    <a
        :href="url"
        :title="title"
        :aria-label="title"
        :data-tag-category="ga.category"
        :data-tag-action="ga.action"
        :data-tag-label="ga.label"
        :target="target"
        class="absolute inset-0 z-10 cursor-pointer focus:ring-2 focus:ring-blue-600 focus:ring-offset-white dark:ring-offset-black focus:ring-offset-2 focus:outline-none"
    >
        <span class="sr-only">{{ title }}</span>
    </a>
</template>
